var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};

export default getDisplayName;


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/util/getDisplayName.js
// module id = 2j4w
// module chunks = 1